/* storybook-check-ignore */
import { Button, ButtonProps, Text } from '@opendoor/bricks/core';
import { css } from '@emotion/react';
import LetterIcon from './icons/LetterIcon';
import { useReducer } from 'react';
import Modal from './Modal';

export default function AppraisalPriceMatchGuaranteeInfo({
  isSellerOfferExperiment = true,
  iconSize = 18,
  buttonProps,
}: {
  isSellerOfferExperiment?: boolean;
  iconSize?: number;
  buttonProps?: Omit<ButtonProps, 'onClick' | 'aria-label' | 'analyticsName'>;
}) {
  const [isModalOpen, toggleModalOpen] = useReducer((s) => !s, false);
  const info = isSellerOfferExperiment
    ? 'We want you to feel confident about your purchase. If the home appraises lower than the price you agree with the seller, we’ll match the appraised price up to $50,000.'
    : "We want you to feel confident about your purchase. If the home appraises at a lower price, we'll match the appraised price up to $50,000.";
  return (
    <>
      <Button
        variant="link"
        analyticsName="cosmos-exclusives-appraisal-price-match-guarantee-info-button"
        aria-label={info}
        display="flex"
        alignItems="center"
        gridGap="5px"
        fontSize="s0"
        fontWeight="semibold"
        color="brand50"
        lineHeight="s00"
        paddingX="0.25rem"
        css={css`
          border-radius: 5px;
          svg path {
            fill: #082de6 !important;
          }
          &:hover {
            opacity: 0.6;
            background-color: var(--colors-neutrals30);
          }
        `}
        onClick={toggleModalOpen}
        {...buttonProps}
      >
        <LetterIcon size={iconSize} />
        Appraisal Price Match Guarantee
      </Button>
      <Modal
        title="Appraisal Price Match Guarantee"
        isOpen={isModalOpen}
        onRequestClose={toggleModalOpen}
      >
        <Text>{info}</Text>
      </Modal>
    </>
  );
}
